"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsonld_context_parser_1 = require("jsonld-context-parser");
/**
 * Utility functions and methods.
 */


var Util =
/*#__PURE__*/
function () {
  function Util(options) {
    _classCallCheck(this, Util);

    this.parsingContext = options.parsingContext;
    this.dataFactory = options.dataFactory || require('@rdfjs/data-model');
    this.rdfFirst = this.dataFactory.namedNode(Util.RDF + 'first');
    this.rdfRest = this.dataFactory.namedNode(Util.RDF + 'rest');
    this.rdfNil = this.dataFactory.namedNode(Util.RDF + 'nil');
    this.rdfType = this.dataFactory.namedNode(Util.RDF + 'type');
  }
  /**
   * Helper function to get the value of a context entry,
   * or fallback to a certain value.
   * @param {IJsonLdContextNormalized} context A JSON-LD context.
   * @param {string} contextKey A pre-defined JSON-LD key in context entries.
   * @param {string} key A context entry key.
   * @param {string} fallback A fallback value for when the given contextKey
   *                          could not be found in the value with the given key.
   * @return {string} The value of the given contextKey in the entry behind key in the given context,
   *                  or the given fallback value.
   */


  _createClass(Util, [{
    key: "validateValueIndexes",

    /**
     * Make sure that @id-@index pairs are equal over all array values.
     * Reject otherwise.
     * @param {any[]} value An array value.
     * @return {Promise<void>} A promise rejecting if conflicts are present.
     */
    value: function () {
      var _validateValueIndexes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(value) {
        var indexHashes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, id, index, existingIndexValue;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.parsingContext.validateValueIndexes) {
                  _context.next = 34;
                  break;
                }

                indexHashes = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 5;
                _iterator = value[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 20;
                  break;
                }

                entry = _step.value;

                if (!(entry && typeof entry === 'object')) {
                  _context.next = 17;
                  break;
                }

                id = entry['@id'];
                index = entry['@index'];

                if (!(id && index)) {
                  _context.next = 17;
                  break;
                }

                existingIndexValue = indexHashes[id];

                if (!(existingIndexValue && existingIndexValue !== index)) {
                  _context.next = 16;
                  break;
                }

                throw new Error("Conflicting @index value for ".concat(id));

              case 16:
                indexHashes[id] = index;

              case 17:
                _iteratorNormalCompletion = true;
                _context.next = 7;
                break;

              case 20:
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 29:
                _context.prev = 29;

                if (!_didIteratorError) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(26);

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 22, 26, 34], [27,, 29, 33]]);
      }));

      function validateValueIndexes(_x) {
        return _validateValueIndexes.apply(this, arguments);
      }

      return validateValueIndexes;
    }()
    /**
     * Convert a given JSON value to an RDF term.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The current JSON key.
     * @param value A JSON value.
     * @param {number} depth The depth the value is at.
     * @param {string[]} keys The path of keys.
     * @return {RDF.Term} An RDF term.
     */

  }, {
    key: "valueToTerm",
    value: function () {
      var _valueToTerm = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(context, key, value, depth, keys) {
        var type, val, valueLanguage, valueType, valueIndex, subValue, typeTerm, listValue;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                type = typeof value;
                _context2.t0 = type;
                _context2.next = _context2.t0 === 'object' ? 4 : _context2.t0 === 'string' ? 110 : _context2.t0 === 'boolean' ? 111 : _context2.t0 === 'number' ? 112 : 113;
                break;

              case 4:
                if (!(value === null || value === undefined)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", null);

              case 6:
                if (!Array.isArray(value)) {
                  _context2.next = 12;
                  break;
                }

                if (!(Util.getContextValueContainer(context, key) === '@list' && value.length === 0)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", this.rdfNil);

              case 9:
                _context2.next = 11;
                return this.validateValueIndexes(value);

              case 11:
                return _context2.abrupt("return", null);

              case 12:
                _context2.next = 14;
                return this.unaliasKeywords(value, keys, depth);

              case 14:
                value = _context2.sent;

                if (!("@value" in value)) {
                  _context2.next = 64;
                  break;
                }

                _context2.t1 = _regeneratorRuntime.keys(value);

              case 17:
                if ((_context2.t2 = _context2.t1()).done) {
                  _context2.next = 34;
                  break;
                }

                key = _context2.t2.value;
                subValue = value[key];
                _context2.t3 = key;
                _context2.next = _context2.t3 === '@value' ? 23 : _context2.t3 === '@language' ? 25 : _context2.t3 === '@type' ? 27 : _context2.t3 === '@index' ? 29 : 31;
                break;

              case 23:
                val = subValue;
                return _context2.abrupt("break", 32);

              case 25:
                valueLanguage = subValue;
                return _context2.abrupt("break", 32);

              case 27:
                valueType = subValue;
                return _context2.abrupt("break", 32);

              case 29:
                valueIndex = subValue;
                return _context2.abrupt("break", 32);

              case 31:
                throw new Error("Unknown value entry '".concat(key, "' in @value: ").concat(JSON.stringify(value)));

              case 32:
                _context2.next = 17;
                break;

              case 34:
                if (!(val === null)) {
                  _context2.next = 36;
                  break;
                }

                return _context2.abrupt("return", null);

              case 36:
                if (!(typeof val === 'object')) {
                  _context2.next = 38;
                  break;
                }

                throw new Error("The value of an '@value' can not be an object, got '".concat(JSON.stringify(val), "'"));

              case 38:
                if (!(this.parsingContext.validateValueIndexes && valueIndex && typeof valueIndex !== 'string')) {
                  _context2.next = 40;
                  break;
                }

                throw new Error("The value of an '@index' must be a string, got '".concat(JSON.stringify(valueIndex), "'"));

              case 40:
                if (!valueLanguage) {
                  _context2.next = 50;
                  break;
                }

                if (!valueType) {
                  _context2.next = 43;
                  break;
                }

                throw new Error("Can not have both '@language' and '@type' in a value: '".concat(JSON.stringify(value), "'"));

              case 43:
                if (!(typeof valueLanguage !== 'string')) {
                  _context2.next = 45;
                  break;
                }

                throw new Error("The value of an '@language' must be a string, got '".concat(JSON.stringify(valueLanguage), "'"));

              case 45:
                if (!(typeof val !== 'string')) {
                  _context2.next = 47;
                  break;
                }

                throw new Error("When an '@language' is set, the value of '@value' must be a string, got '".concat(JSON.stringify(val), "'"));

              case 47:
                return _context2.abrupt("return", this.dataFactory.literal(val, valueLanguage));

              case 50:
                if (!valueType) {
                  _context2.next = 59;
                  break;
                }

                if (!(typeof valueType !== 'string')) {
                  _context2.next = 53;
                  break;
                }

                throw new Error("The value of an '@type' must be a string, got '".concat(JSON.stringify(valueType), "'"));

              case 53:
                typeTerm = this.createVocabOrBaseTerm(context, valueType);

                if (typeTerm) {
                  _context2.next = 56;
                  break;
                }

                return _context2.abrupt("return", null);

              case 56:
                if (!(typeTerm.termType !== 'NamedNode')) {
                  _context2.next = 58;
                  break;
                }

                throw new Error("Illegal value type (".concat(typeTerm.termType, "): ").concat(valueType));

              case 58:
                return _context2.abrupt("return", this.dataFactory.literal(val, typeTerm));

              case 59:
                _context2.next = 61;
                return this.valueToTerm({}, key, val, depth, keys);

              case 61:
                return _context2.abrupt("return", _context2.sent);

              case 64:
                if (!('@set' in value)) {
                  _context2.next = 70;
                  break;
                }

                if (!(Object.keys(value).length > 1)) {
                  _context2.next = 67;
                  break;
                }

                throw new Error("Found illegal neighbouring entries next to @set in value: ".concat(JSON.stringify(value)));

              case 67:
                return _context2.abrupt("return", null);

              case 70:
                if (!('@list' in value)) {
                  _context2.next = 93;
                  break;
                }

                if (!(Object.keys(value).length > 1)) {
                  _context2.next = 73;
                  break;
                }

                throw new Error("Found illegal neighbouring entries next to @set in value: ".concat(JSON.stringify(value)));

              case 73:
                listValue = value["@list"]; // We handle lists at value level so we can emit earlier, so this is handled already when we get here.
                // Empty anonymous lists are emitted at this place, because our streaming algorithm doesn't detect those.

                if (!Array.isArray(listValue)) {
                  _context2.next = 82;
                  break;
                }

                if (!(listValue.length === 0)) {
                  _context2.next = 79;
                  break;
                }

                return _context2.abrupt("return", this.rdfNil);

              case 79:
                return _context2.abrupt("return", null);

              case 80:
                _context2.next = 91;
                break;

              case 82:
                _context2.t4 = this;
                _context2.next = 85;
                return this.parsingContext.getContext(keys);

              case 85:
                _context2.t5 = _context2.sent;
                _context2.t6 = key;
                _context2.t7 = listValue;
                _context2.t8 = depth - 1;
                _context2.t9 = keys.slice(0, -1);
                return _context2.abrupt("return", _context2.t4.valueToTerm.call(_context2.t4, _context2.t5, _context2.t6, _context2.t7, _context2.t8, _context2.t9));

              case 91:
                _context2.next = 110;
                break;

              case 93:
                if (!('@reverse' in value)) {
                  _context2.next = 97;
                  break;
                }

                return _context2.abrupt("return", null);

              case 97:
                if (!("@id" in value)) {
                  _context2.next = 105;
                  break;
                }

                if (!(value["@type"] === '@vocab')) {
                  _context2.next = 102;
                  break;
                }

                return _context2.abrupt("return", this.createVocabOrBaseTerm(context, value["@id"]));

              case 102:
                return _context2.abrupt("return", this.resourceToTerm(context, value["@id"]));

              case 103:
                _context2.next = 110;
                break;

              case 105:
                if (!this.parsingContext.emittedStack[depth + 1]) {
                  _context2.next = 109;
                  break;
                }

                return _context2.abrupt("return", this.parsingContext.idStack[depth + 1] || (this.parsingContext.idStack[depth + 1] = this.dataFactory.blankNode()));

              case 109:
                return _context2.abrupt("return", null);

              case 110:
                return _context2.abrupt("return", this.stringValueToTerm(context, key, value, null));

              case 111:
                return _context2.abrupt("return", this.stringValueToTerm(context, key, Boolean(value).toString(), this.dataFactory.namedNode(Util.XSD_BOOLEAN)));

              case 112:
                return _context2.abrupt("return", this.stringValueToTerm(context, key, value, this.dataFactory.namedNode(value % 1 === 0 ? Util.XSD_INTEGER : Util.XSD_DOUBLE)));

              case 113:
                this.parsingContext.emitError(new Error("Could not determine the RDF type of a ".concat(type)));

              case 114:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function valueToTerm(_x2, _x3, _x4, _x5, _x6) {
        return _valueToTerm.apply(this, arguments);
      }

      return valueToTerm;
    }()
    /**
     * Convert a given JSON key to an RDF predicate term,
     * based on @vocab.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node.
     */

  }, {
    key: "predicateToTerm",
    value: function predicateToTerm(context, key) {
      var expanded = jsonld_context_parser_1.ContextParser.expandTerm(key, context, true); // Immediately return if the predicate was disabled in the context

      if (!expanded) {
        return null;
      } // Check if the predicate is a blank node


      if (expanded[0] === '_' && expanded[1] === ':') {
        if (this.parsingContext.produceGeneralizedRdf) {
          return this.dataFactory.blankNode(expanded.substr(2));
        } else {
          return null;
        }
      } // Check if the predicate is a valid IRI


      if (Util.isValidIri(expanded)) {
        return this.dataFactory.namedNode(expanded);
      } else {
        if (expanded && this.parsingContext.errorOnInvalidProperties) {
          this.parsingContext.emitError(new Error("Invalid predicate IRI: ".concat(expanded)));
        } else {
          return null;
        }
      }
    }
    /**
     * Convert a given JSON key to an RDF resource term or blank node,
     * based on @base.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node or null.
     */

  }, {
    key: "resourceToTerm",
    value: function resourceToTerm(context, key) {
      if (key.startsWith('_:')) {
        return this.dataFactory.blankNode(key.substr(2));
      }

      var iri = jsonld_context_parser_1.ContextParser.expandTerm(key, context, false);

      if (!Util.isValidIri(iri)) {
        if (iri && this.parsingContext.errorOnInvalidProperties) {
          this.parsingContext.emitError(new Error("Invalid resource IRI: ".concat(iri)));
        } else {
          return null;
        }
      }

      return this.dataFactory.namedNode(iri);
    }
    /**
     * Convert a given JSON key to an RDF resource term.
     * It will do this based on the @vocab,
     * and fallback to @base.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node or null.
     */

  }, {
    key: "createVocabOrBaseTerm",
    value: function createVocabOrBaseTerm(context, key) {
      if (key.startsWith('_:')) {
        return this.dataFactory.blankNode(key.substr(2));
      }

      var expanded = jsonld_context_parser_1.ContextParser.expandTerm(key, context, true);

      if (expanded === key) {
        expanded = jsonld_context_parser_1.ContextParser.expandTerm(key, context, false);
      }

      if (!Util.isValidIri(expanded)) {
        if (expanded && this.parsingContext.errorOnInvalidProperties) {
          this.parsingContext.emitError(new Error("Invalid term IRI: ".concat(expanded)));
        } else {
          return null;
        }
      }

      return this.dataFactory.namedNode(expanded);
    }
    /**
     * Ensure that the given value becomes a string.
     * @param {string | number} value A string or number.
     * @param {NamedNode} datatype The intended datatype.
     * @return {string} The returned string.
     */

  }, {
    key: "intToString",
    value: function intToString(value, datatype) {
      if (typeof value === 'number') {
        if (Number.isFinite(value)) {
          var isInteger = value % 1 === 0;

          if (isInteger && datatype.value !== Util.XSD_DOUBLE) {
            return Number(value).toString();
          } else {
            return value.toExponential(15).replace(/(\d)0*e\+?/, '$1E');
          }
        } else {
          return value > 0 ? 'INF' : '-INF';
        }
      } else {
        return value;
      }
    }
    /**
     * Convert a given JSON string value to an RDF term.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The current JSON key.
     * @param {string} value A JSON value.
     * @param {NamedNode} defaultDatatype The default datatype for the given value.
     * @return {RDF.Term} An RDF term or null.
     */

  }, {
    key: "stringValueToTerm",
    value: function stringValueToTerm(context, key, value, defaultDatatype) {
      // Check the datatype from the context
      var contextType = Util.getContextValueType(context, key);

      if (contextType) {
        if (contextType === '@id') {
          return this.resourceToTerm(context, this.intToString(value, defaultDatatype));
        } else if (contextType === '@vocab') {
          return this.createVocabOrBaseTerm(context, this.intToString(value, defaultDatatype));
        } else {
          defaultDatatype = this.dataFactory.namedNode(contextType);
        }
      } // If we don't find such a datatype, check the language from the context


      if (!defaultDatatype) {
        var contextLanguage = Util.getContextValueLanguage(context, key);

        if (contextLanguage) {
          return this.dataFactory.literal(this.intToString(value, defaultDatatype), contextLanguage);
        }
      } // If all else fails, make a literal based on the default content type


      return this.dataFactory.literal(this.intToString(value, defaultDatatype), defaultDatatype);
    }
    /**
     * If the key is not a keyword, try to check if it is an alias for a keyword,
     * and if so, un-alias it.
     * @param {string} key A key, can be falsy.
     * @param {string[]} keys The path of keys.
     * @param {number} depth The depth to
     * @param {boolean} disableCache If the cache should be disabled
     * @return {Promise<string>} A promise resolving to the key itself, or another key.
     */

  }, {
    key: "unaliasKeyword",
    value: function () {
      var _unaliasKeyword = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(key, keys, depth, disableCache) {
        var cachedUnaliasedKeyword, context, unliased;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!Number.isInteger(key)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", key);

              case 2:
                if (disableCache) {
                  _context3.next = 6;
                  break;
                }

                cachedUnaliasedKeyword = this.parsingContext.unaliasedKeywordCacheStack[depth];

                if (!cachedUnaliasedKeyword) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", cachedUnaliasedKeyword);

              case 6:
                if (Util.isKeyword(key)) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 9;
                return this.parsingContext.getContext(keys);

              case 9:
                context = _context3.sent;
                unliased = context[key];

                if (unliased && typeof unliased === 'object') {
                  unliased = unliased['@id'];
                }

                if (Util.isKeyword(unliased)) {
                  key = unliased;
                }

              case 13:
                return _context3.abrupt("return", disableCache ? key : this.parsingContext.unaliasedKeywordCacheStack[depth] = key);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function unaliasKeyword(_x7, _x8, _x9, _x10) {
        return _unaliasKeyword.apply(this, arguments);
      }

      return unaliasKeyword;
    }()
    /**
     * Unalias the keyword of the parent.
     * This adds a safety check if no parent exist.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth The current depth.
     * @return {Promise<any>} A promise resolving to the parent key, or another key.
     */

  }, {
    key: "unaliasKeywordParent",
    value: function () {
      var _unaliasKeywordParent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(keys, depth) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.unaliasKeyword(depth > 0 && keys[depth - 1], keys, depth - 1);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function unaliasKeywordParent(_x11, _x12) {
        return _unaliasKeywordParent.apply(this, arguments);
      }

      return unaliasKeywordParent;
    }()
    /**
     * Un-alias all keywords in the given hash.
     * @param {{[p: string]: any}} hash A hash object.
     * @param {string[]} keys The path of keys.
     * @param {number} depth The depth.
     * @return {Promise<{[p: string]: any}>} A promise resolving to the new hash.
     */

  }, {
    key: "unaliasKeywords",
    value: function () {
      var _unaliasKeywords = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(hash, keys, depth) {
        var newHash, key;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                newHash = {};
                _context5.t0 = _regeneratorRuntime.keys(hash);

              case 2:
                if ((_context5.t1 = _context5.t0()).done) {
                  _context5.next = 10;
                  break;
                }

                key = _context5.t1.value;
                _context5.next = 6;
                return this.unaliasKeyword(key, keys, depth + 1, true);

              case 6:
                _context5.t2 = _context5.sent;
                newHash[_context5.t2] = hash[key];
                _context5.next = 2;
                break;

              case 10:
                return _context5.abrupt("return", newHash);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function unaliasKeywords(_x13, _x14, _x15) {
        return _unaliasKeywords.apply(this, arguments);
      }

      return unaliasKeywords;
    }()
    /**
     * Check if we are processing a literal at the given depth.
     * This will also check higher levels,
     * because if a parent is a literal,
     * then the deeper levels are definitely a literal as well.
     * @param {number} depth The depth.
     * @return {boolean} If we are processing a literal.
     */

  }, {
    key: "isLiteral",
    value: function isLiteral(depth) {
      for (var i = depth; i >= 0; i--) {
        if (this.parsingContext.literalStack[i]) {
          return true;
        }
      }

      return false;
    }
    /**
     * Check how many parents should be skipped for checking the @graph for the given node.
     *
     * @param {number} depth The depth of the node.
     * @param {any[]} keys An array of keys.
     * @return {number} The graph depth offset.
     */

  }, {
    key: "getDepthOffsetGraph",
    value: function () {
      var _getDepthOffsetGraph = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(depth, keys) {
        var i;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                i = depth - 1;

              case 1:
                if (!(i > 0)) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 4;
                return this.unaliasKeyword(keys[i], keys, i);

              case 4:
                _context6.t0 = _context6.sent;

                if (!(_context6.t0 === '@graph')) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", depth - i - 1);

              case 7:
                i--;
                _context6.next = 1;
                break;

              case 10:
                return _context6.abrupt("return", -1);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getDepthOffsetGraph(_x16, _x17) {
        return _getDepthOffsetGraph.apply(this, arguments);
      }

      return getDepthOffsetGraph;
    }()
    /**
     * Check if the given subject is of a valid type.
     * This should be called when applying @reverse'd properties.
     * @param {Term} subject A subject.
     */

  }, {
    key: "validateReverseSubject",
    value: function validateReverseSubject(subject) {
      if (subject.termType === 'Literal') {
        throw new Error("Found illegal literal in subject position: ".concat(subject.value));
      }
    }
    /**
     * Get the default graph.
     * @return {Term} An RDF term.
     */

  }, {
    key: "getDefaultGraph",
    value: function getDefaultGraph() {
      return this.parsingContext.defaultGraph || this.dataFactory.defaultGraph();
    }
  }], [{
    key: "getContextValue",
    value: function getContextValue(context, contextKey, key, fallback) {
      var entry = context[key];

      if (!entry) {
        return fallback;
      }

      var type = entry[contextKey];
      return type === undefined ? fallback : type;
    }
    /**
     * Get the container type of the given key in the context.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The container type.
     */

  }, {
    key: "getContextValueContainer",
    value: function getContextValueContainer(context, key) {
      return Util.getContextValue(context, '@container', key, '@set');
    }
    /**
     * Get the node type of the given key in the context.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The node type.
     */

  }, {
    key: "getContextValueType",
    value: function getContextValueType(context, key) {
      return Util.getContextValue(context, '@type', key, null);
    }
    /**
     * Get the node type of the given key in the context.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The node type.
     */

  }, {
    key: "getContextValueLanguage",
    value: function getContextValueLanguage(context, key) {
      return Util.getContextValue(context, '@language', key, context['@language'] || null);
    }
    /**
     * Check if the given key in the context is a reversed property.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {boolean} If the context value has a @reverse key.
     */

  }, {
    key: "isContextValueReverse",
    value: function isContextValueReverse(context, key) {
      return !!Util.getContextValue(context, '@reverse', key, null);
    }
    /**
     * Check if the given key refers to a reversed property.
     * @param {IJsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The property key.
     * @param {string} parentKey The parent key.
     * @return {boolean} If the property must be reversed.
     */

  }, {
    key: "isPropertyReverse",
    value: function isPropertyReverse(context, key, parentKey) {
      // '!==' is needed because reversed properties in a @reverse container should cancel each other out.
      return parentKey === '@reverse' !== Util.isContextValueReverse(context, key);
    }
    /**
     * Check if the given key is a keyword.
     * @param {string} key A key, can be falsy.
     * @return {boolean} If the given key starts with an @.
     */

  }, {
    key: "isKeyword",
    value: function isKeyword(key) {
      return typeof key === 'string' && key[0] === '@';
    }
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */

  }, {
    key: "isValidIri",
    value: function isValidIri(iri) {
      return jsonld_context_parser_1.ContextParser.isValidIri(iri);
    }
  }]);

  return Util;
}();

Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
Util.XSD_BOOLEAN = Util.XSD + 'boolean';
Util.XSD_INTEGER = Util.XSD + 'integer';
Util.XSD_DOUBLE = Util.XSD + 'double';
Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
exports.Util = Util;